/* ═══════════════════════════════════════════════════════════════════════
   classic-solitaire-mobile.js
   Mobile slideshow + sticky CTA for the engagement-ring setting template.

   Loaded as a separate asset (not appended to classic-solitaire.js) because
   Shopify's asset minifier comma-chains adjacent IIFEs in the same file,
   which short-circuits if the prior IIFE throws. As a standalone file,
   this runs in its own evaluation context.
   ═══════════════════════════════════════════════════════════════════════ */
(function(){
  // ── Mobile slideshow nav (dots + thumbs) ──────────────────────────────
  var g = document.querySelector('.gal-grid'),
      d = document.getElementById('sp-dots'),
      t = document.getElementById('sp-mobile-thumbs');
  if (g && d && t) {
    function build() {
      var cells = g.querySelectorAll('.gal-slot');
      d.innerHTML = ''; t.innerHTML = '';
      for (var i = 0; i < cells.length; i++) {
        // Dot
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sp-dot' + (i === 0 ? ' active' : '');
        dot.dataset.idx = String(i);
        dot.setAttribute('aria-label', 'Image ' + (i + 1));
        dot.onclick = function(){ g.scrollTo({ left: parseInt(this.dataset.idx) * g.offsetWidth, behavior: 'smooth' }); };
        d.appendChild(dot);
        // Thumb
        var th = document.createElement('button');
        th.type = 'button';
        th.className = 'sp-mobile-thumb' + (i === 0 ? ' active' : '');
        th.dataset.idx = String(i);
        th.setAttribute('aria-label', 'Go to image ' + (i + 1));
        var img = cells[i].querySelector('img');
        var iframe = cells[i].querySelector('iframe');
        if (img && img.src) {
          var ti = document.createElement('img');
          ti.src = img.src; ti.alt = '';
          th.appendChild(ti);
        } else if (iframe) {
          th.classList.add('sp-mobile-thumb--3d');
          th.textContent = '3D';
        }
        th.onclick = function(){ g.scrollTo({ left: parseInt(this.dataset.idx) * g.offsetWidth, behavior: 'smooth' }); };
        t.appendChild(th);
      }
    }
    build();

    // Next-image arrow over the 3D viewer (clicked when swipe-blocked by iframe)
    var arrow = document.querySelector('[data-sp-3d-next]');
    if (arrow) {
      arrow.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();
        g.scrollTo({ left: g.offsetWidth, behavior: 'smooth' });
      });
    }

    // Sync active dot/thumb + arrow visibility as the user swipes the gallery
    var st;
    function syncToScrollPosition(){
      if (!window.matchMedia('(max-width: 900px)').matches) {
        if (arrow) arrow.style.display = 'none';
        return;
      }
      var idx = Math.round(g.scrollLeft / g.offsetWidth);
      d.querySelectorAll('.sp-dot').forEach(function(e, i){ e.classList.toggle('active', i === idx); });
      t.querySelectorAll('.sp-mobile-thumb').forEach(function(e, i){ e.classList.toggle('active', i === idx); });
      // Arrow shows only on the first cell (the 3D viewer)
      if (arrow) arrow.style.display = (idx === 0) ? 'flex' : 'none';
    }
    g.addEventListener('scroll', function(){
      clearTimeout(st);
      st = setTimeout(syncToScrollPosition, 50);
    });
    // Initial sync on load + on resize (desktop ↔ mobile transitions)
    setTimeout(syncToScrollPosition, 100);
    window.addEventListener('resize', syncToScrollPosition);
  }

  // ── Sticky CTA: show when real button (#sp-choose-btn) is offscreen ───
  // Uses a scroll listener (more reliable cross-browser than IntersectionObserver
  // for this use case, especially on iOS Safari).
  var rb = document.getElementById('sp-choose-btn'),
      sc = document.getElementById('sp-sticky-cta'),
      sb = document.getElementById('sp-sticky-cta-btn'),
      sp = document.getElementById('sp-sticky-cta-price');
  if (rb && sc && sb) {
    function syncPrice() {
      var pe = document.getElementById('sp-price');
      if (pe && sp) sp.textContent = pe.textContent.trim();
    }
    syncPrice();
    try {
      var pe = document.getElementById('sp-price');
      if (pe) new MutationObserver(syncPrice).observe(pe, { childList: true, subtree: true, characterData: true });
    } catch(e) {}

    // Scroll-based visibility — flips .is-visible based on whether the
    // real CTA is currently in the viewport. Uses a setTimeout debounce
    // (16ms) instead of requestAnimationFrame so it fires reliably even
    // when the tab is hidden / in the background.
    function updateStickyVisibility() {
      // Only show on small viewports (matches the @media (max-width:640px) rule)
      if (!window.matchMedia('(max-width: 640px)').matches) {
        sc.classList.remove('is-visible');
        return;
      }
      var rect = rb.getBoundingClientRect();
      var visible = rect.bottom > 0 && rect.top < window.innerHeight;
      sc.classList.toggle('is-visible', !visible);
    }
    var scrollTimer;
    function onScrollOrResize() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateStickyVisibility, 16);
    }
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize);
    // Initial check (after the page settles)
    setTimeout(updateStickyVisibility, 100);
    // Recompute after images load (layout shifts)
    window.addEventListener('load', function(){ setTimeout(updateStickyVisibility, 300); });

    sb.addEventListener('click', function(){ rb.click(); });
  }
})();

/* ═══════════════════════════════════════════════════════════════════════
   Reviews-module adapter — mirrors Supabase rating data into the existing
   .sp-reviews-row markup. The reviews-module snippet populates a hidden
   #ep-header-stars element when reviews exist; this watches that element
   and copies the rating + count into .sp-rating-num / .sp-review-count.

   Falls back to the metafield-based row (already rendered in the Liquid)
   if Supabase doesn't respond within 5 seconds.
   ═══════════════════════════════════════════════════════════════════════ */
;(function(){
  var srcRow = document.getElementById('sp-reviews-row');
  var mirror = document.getElementById('ep-header-stars');
  var mirrorText = document.getElementById('ep-header-rating-text');
  if (!srcRow || !mirror || !mirrorText) return;
  var ratingNumEl = srcRow.querySelector('.sp-rating-num');
  var reviewCountEl = srcRow.querySelector('.sp-review-count');
  var stars = srcRow.querySelectorAll('.sp-star');
  var supaResolved = false;

  function syncFromSupabase(){
    // reviews-module's JS sets mirror.style.display = '' when reviews exist.
    // If it stays "none", Supabase loaded with 0 reviews -> keep srcRow hidden.
    var visible = mirror.style.display !== 'none';
    if (!visible){ supaResolved = true; return; }
    var t = mirrorText.textContent.trim();
    var m = t.match(/(\d+(?:\.\d+)?)\s*\((\d+)\s*review/i);
    if (!m) return;
    var rating = parseFloat(m[1]), count = parseInt(m[2], 10);
    if (ratingNumEl) ratingNumEl.textContent = rating.toFixed(1);
    if (reviewCountEl) reviewCountEl.textContent = '(' + count + ' Review' + (count === 1 ? '' : 's') + ')';
    var floor = Math.round(rating);
    stars.forEach(function(s, i){ s.classList.toggle('sp-star--filled', (i + 1) <= floor); });
    srcRow.style.display = '';
    supaResolved = true;
  }

  new MutationObserver(syncFromSupabase).observe(mirror, { attributes: true, attributeFilter: ['style'] });

  // 5-second fallback: show the metafield-based row if Supabase is unreachable.
  setTimeout(function(){
    if (supaResolved) return;
    var summary = document.getElementById('ep-rv-summary');
    if (summary && /loading/i.test(summary.textContent)) {
      srcRow.style.display = '';
    }
  }, 5000);
})();
